import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '../../services/translate/translate.service';

@Component({
    selector: 'quick-help-compliance-status',
    templateUrl: './quick-help-compliance-status.component.html',
    standalone: false,
})
export class QuickHelpComplianceStatusComponent implements OnInit {
    @Input() type: string = '';
    @Input() totalPagesCount: number = 0;
    @Input() totalPageIssues: number = 0;
    @Input() data: any;

    title: string = '';
    loading: boolean = false;

    constructor (private translateService: TranslateService) {}

    ngOnInit (): void {
        this.title = this.type === 'policy'
            ? this.translateService.getString('Policy note')
            : this.translateService.getString('Quick help');
    }

    getPagesDone (): number {
        if (isNaN(this.totalPagesCount) || isNaN(this.totalPageIssues) || this.totalPagesCount < this.totalPageIssues) {
            return 0;
        }
        return this.totalPagesCount - this.totalPageIssues;
    }

    getCompliancePercentage (): number {
        const pagesInCompliance = this.getPagesDone();
        let compliance = pagesInCompliance / this.totalPagesCount;
        if (compliance > 0.99 && pagesInCompliance < this.totalPagesCount) {
            compliance = 0.99;
        } else if (compliance < 0.1 && pagesInCompliance) {
            compliance = 0.01;
        }
        return compliance;
    }
}
